import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Register from './components/Register';
import TimeSlots from './components/TimeSlots';
import Posts from './components/Posts';
import PostDetail from './components/PostDetail';
import AdminPanel from './components/AdminPanel';
import PolicyEN from './components/PolicyEN';
import PolicyCN from './components/PolicyCN';
import ResetPassword from './components/ResetPassword';
import Profile from './components/Profile';
import { getAuthToken, setAuthToken, removeAuthToken } from './utils/auth';
import { isAdmin } from './utils/admin';
import api from './utils/api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      setLoading(false);
      return;
    }
    // Validate token and restore user session
    api.get('/auth/me')
      .then((res) => {
        setUser({ ...res.data.user, token });
      })
      .catch(() => {
        removeAuthToken();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = (userData, token) => {
    setAuthToken(token);
    setUser({ ...userData, token });
  };

  const handleLogout = () => {
    removeAuthToken();
    setUser(null);
  };

  const handleProfileUpdate = (updatedUser) => {
    setUser((prev) => prev ? { ...prev, ...updatedUser, token: prev.token } : null);
  };

  const handleAcknowledgePolicy = async () => {
    try {
      await api.post('/auth/acknowledge-policy');
      const res = await api.get('/auth/me');
      setUser({ ...res.data.user, token: getAuthToken() });
    } catch (err) {
      console.error('Failed to acknowledge policy', err);
    }
  };

  const showPolicyBar = user && !user.policy_acknowledged_at;

  if (loading) {
    return <div className="container">Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Navbar user={user} onLogout={handleLogout} />
        {showPolicyBar && !isAdmin(user) && (
          <div style={{ background: 'var(--warning, #ffc107)', color: '#000', padding: '10px 16px', textAlign: 'center' }}>
            Please acknowledge the Terms & Policy to use the site.{' '}
            <Link to="/policy/en" style={{ fontWeight: 600, textDecoration: 'underline', color: '#000' }}>View policy & acknowledge</Link>
          </div>
        )}
        <div className="container">
          <Routes>
            <Route path="/login" element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} />
            <Route path="/register" element={!user ? <Register onLogin={handleLogin} /> : <Navigate to="/" />} />
            <Route path="/reset-password" element={!user ? <ResetPassword /> : <Navigate to="/" />} />
            <Route path="/profile" element={<Profile user={user} onProfileUpdate={handleProfileUpdate} />} />
            <Route path="/" element={<TimeSlots user={user} />} />
            <Route path="/posts" element={<Posts user={user} />} />
            <Route path="/posts/:id" element={<PostDetail user={user} />} />
            <Route path="/admin" element={<AdminPanel user={user} />} />
            <Route path="/policy" element={<Navigate to="/policy/en" replace />} />
            <Route path="/policy/en" element={<PolicyEN user={user} onAcknowledge={handleAcknowledgePolicy} />} />
            <Route path="/policy/cn" element={<PolicyCN user={user} onAcknowledge={handleAcknowledgePolicy} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;


